import { useEffect, useState } from "react";
import { Percent, DollarSign, BadgePercent } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const mxn = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function DescuentoOtroModal({ abierto, subtotal, onClose, onAplicar }) {
  const [modo, setModo] = useState("pct");
  const [valor, setValor] = useState("");
  useEffect(() => { if (abierto) { setModo("pct"); setValor(""); } }, [abierto]);

  const v = parseFloat(valor) || 0;
  const pct = modo === "pct" ? Math.min(100, Math.max(0, v)) : subtotal > 0 ? Math.min(100, Math.max(0, Math.round((v / subtotal) * 10000) / 10000 * 100)) : 0;
  const monto = Math.round(subtotal * pct) / 100;
  const valido = v > 0 && (modo === "pct" ? v <= 100 : v <= subtotal + 0.001);

  function aplicar(e) {
    e.preventDefault();
    if (!valido) return;
    const pctFinal = Math.round(pct * 100) / 100;
    onAplicar(pctFinal, modo === "pct" ? `Descuento ${pctFinal}% aplicado a la venta` : `Descuento de ${mxn(monto)} (${pctFinal}%) aplicado a la venta`);
  }

  return (
    <Dialog open={abierto} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="descuento-otro-modal">
        <DialogHeader>
          <div className="eyebrow">Descuento manual</div>
          <DialogTitle className="font-display text-xl font-bold flex items-center gap-2"><BadgePercent className="w-5 h-5 text-brand-amber" /> Otro descuento</DialogTitle>
        </DialogHeader>
        <form onSubmit={aplicar} className="space-y-4">
          <div className="flex gap-1 bg-brand-surface p-1 rounded-full">
            <button type="button" data-testid="descuento-modo-pct" onClick={() => { setModo("pct"); setValor(""); }} className={`flex-1 h-9 rounded-full text-sm font-semibold flex items-center justify-center gap-1.5 transition-colors duration-150 ${modo === "pct" ? "bg-brand-ink text-white" : "text-brand-slate hover:text-brand-ink"}`}><Percent className="w-3.5 h-3.5" /> Porcentaje</button>
            <button type="button" data-testid="descuento-modo-monto" onClick={() => { setModo("monto"); setValor(""); }} className={`flex-1 h-9 rounded-full text-sm font-semibold flex items-center justify-center gap-1.5 transition-colors duration-150 ${modo === "monto" ? "bg-brand-ink text-white" : "text-brand-slate hover:text-brand-ink"}`}><DollarSign className="w-3.5 h-3.5" /> Cantidad $</button>
          </div>
          <div>
            <label className="eyebrow">{modo === "pct" ? "Porcentaje de descuento" : "Cantidad a descontar"}</label>
            <div className="relative mt-1">
              <input data-testid="descuento-otro-input" autoFocus type="number" min="0" step={modo === "pct" ? "0.5" : "0.01"} max={modo === "pct" ? 100 : subtotal} value={valor} onChange={(e) => setValor(e.target.value)} className="field font-mono text-lg h-12 pr-10" placeholder={modo === "pct" ? "Ej. 12.5" : "Ej. 50"} />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-muted font-bold">{modo === "pct" ? "%" : "$"}</span>
            </div>
          </div>
          <div className="rounded-xl bg-brand-surface px-3 py-2 text-sm space-y-0.5" data-testid="descuento-otro-preview">
            <div className="flex justify-between text-brand-slate"><span>Precio lista</span><b className="font-mono">{mxn(subtotal)}</b></div>
            <div className="flex justify-between text-rose-700"><span>Descuento ({(Math.round(pct * 100) / 100)}%)</span><b className="font-mono">-{mxn(monto)}</b></div>
            <div className="flex justify-between text-brand-ink font-bold border-t border-brand-line pt-1 mt-1"><span>Total</span><b className="font-mono">{mxn(subtotal - monto)}</b></div>
          </div>
          {!valido && v > 0 && <div className="text-xs text-rose-600" data-testid="descuento-otro-error">{modo === "pct" ? "El porcentaje no puede exceder 100%." : "La cantidad no puede exceder el precio de lista."}</div>}
          <button type="submit" data-testid="descuento-otro-aplicar" disabled={!valido} className="btn-amber w-full h-11 disabled:opacity-50">Aplicar descuento</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
